/**
 * Placeholder for a sidebar destination that is planned and not built.
 * The module and page name come from plannedModules.js so the label matches
 * the link the user clicked.
 */
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Construction } from 'lucide-react';
import { findPlannedPage, plannedPageLabel } from '../layouts/plannedModules';

const NotAvailableYet = () => {
  const { pathname } = useLocation();
  const entry = findPlannedPage(pathname);

  return (
    <div className="flex min-h-[420px] flex-col items-center justify-center px-4 text-center" data-testid="not-available-yet">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-amber-100">
        <Construction className="h-8 w-8 text-amber-700" aria-hidden="true" />
      </div>
      <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-amber-700">Planned</p>
      <h1 className="mb-2 text-2xl font-bold text-slate-900">Not available yet</h1>
      <p className="mb-2 text-sm font-medium text-slate-800" data-testid="not-available-label">
        {plannedPageLabel(entry)}
      </p>
      <p className="mb-6 max-w-md text-slate-500">
        This part of K12 ERP is on the roadmap and does not have a working page yet.
      </p>
      <Link
        to="/dashboard"
        className="inline-flex items-center rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
        data-testid="not-available-dashboard-link"
      >
        Back to dashboard
      </Link>
    </div>
  );
};

export default NotAvailableYet;
